// extracted by mini-css-extract-plugin
export default {"container":"TimerButton_container__TZ6xr","text":"TimerButton_text__4+S00","button":"TimerButton_button__sexum","timerActive":"TimerButton_timerActive__jPmEM"};